app.factory("StudentExamsService", ["$http",
    function ($http) {
        var StudentExamsService = {};

        StudentExamsService.getExamList = function () {
            return $http.get("/exams/student/list", {});
        };

        StudentExamsService.getSessionsWithFreeSeats = function (params) {
            return $http.post("/exams/student/session/available", {examItemId: params.examItemId})
                .then(function (resp) {
                    return resp.data;
                });
        };

        StudentExamsService.getSessionsWithFreeSeatsBySubject = function (params) {
            console.log("ha2");
            return $http.post("/exams/student/session/available/by-subject", {chosenSubject: params.chosenSubject})
                .then(function (resp) {
                    console.log("ha");
                    return resp.data;
                });
        };

        StudentExamsService.moveExam = function (params) {
            return $http.post("/exams/student/session/move", {
                examItemId: params.examItemId,
                examSessionId: params.examSessionId
            })
                .then(function (resp) {
                    return resp.data;
                })
        };

        StudentExamsService.getAvailableSubjects = function () {
            return $http.get("/exams/student/subject/available").then(function (resp) {
                return resp.data;
            });
        };

        StudentExamsService.requestReseat = function (params) {
            return $http.post("/exams/student/request/reseat", {
                subjectId: params.subjectId,
                subjectSelectionId: params.subjectSelectionId,
                examSessionId: params.examSessionId
            }).then(function (resp) {
                return resp.data;
            });
        };

        return StudentExamsService;
    }
]);
